import React, { useState } from 'react';

const IPTextArea = (props) => {

    const [val, setVal] = useState(props.obj.value);
    const change = (val) => {
        setVal(val);
        props.setValue(props.obj.id, val)
    }

    return (
        <div className="form-group col-md-12">
            <label>{props.obj.label}</label>
            <textarea type="text" value={val} onChange={(e) => change(e.target.value)} className="form-control" rows="10" readOnly={props.readonly} />
        </div>

    );
}


export default IPTextArea;